package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.restaurant_manager.components.restaurant_project.list

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.style.toModifier
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.VerticalScrollBehavior
import org.hs_soft.runmynesto.domain.config.scrollBar
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.restaurant_project.RestaurantProject
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.restaurant_project.Room
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnitLength
import org.jetbrains.compose.web.css.LineStyle

@Composable
fun Projects(
    windowSizeMode: WindowSizeModeEnum,
    modifier: Modifier = VerticalScrollBehavior.toModifier(),
    selectedRestaurantRoom: Room?,
    selectedRestaurantProject: RestaurantProject?,
    restaurantProjects: List<RestaurantProject?>?,
    width: CSSSizeValue<out CSSUnitLength>,
    onProjectItemClick: (RestaurantProject?) -> Unit,
    onFloorClick: (RestaurantProject?) -> Unit,
    onRoomClick: (Room?, RestaurantProject?) -> Unit,
) {
    Column(
        modifier = modifier
            .overflow(Overflow.Auto)
            .thenIf(
                selectedRestaurantRoom==null,
                modifier.fillMaxHeight()
            )
            .width(width)
            .border(
                color = Theme.ActionDisabledBackground.rgb,
                style = LineStyle.Solid,
                width = Dimen.smallThickness
            )
            .scrollBar()
            .borderRadius(Dimen.semiLargeRadius)

    )
    {
        restaurantProjects?.forEach {restaurantProject->

            ProjectItem(
                windowSizeMode = windowSizeMode,
                projectItemIsSelected=selectedRestaurantProject?.id==restaurantProject?.id,
                model =restaurantProject,
                isExpandAll = true,
                onProjectItemClick = {
                    onProjectItemClick(it)
                },
                content = {
                    Floors(
                        floors=restaurantProject?.floors?: listOf(),
                        selectedRestaurantRoom=selectedRestaurantRoom,
                        windowSizeMode = windowSizeMode,
                        isExpandAll = true,
                        onFloorClick = {
                            onFloorClick(restaurantProject)
                        },
                        onRoomClick = {
                            onRoomClick(it,restaurantProject)
                        }

                    )
                }
            )


        }



    }

}